import React from "react";
import SectionShell from "../../components/sections/SectionShell";
import EmailManagement from "../crm/EmailManagement";
import PrivacyEmailManager from "../PrivacyEmailManager";

// Email merges the old /crm/emails page (compose, inbox, sent log) and the
// privacy/legal email templates. Every email API behind it is admin-only.
// Subscriber broadcast stays disabled until the compliance rewrite lands.
export const EMAIL_TABS = [
  { id: "compose", label: "Compose", icon: "✉️", render: () => <EmailManagement view="compose" />,
    description: "Send a one-off branded email. Subscriber broadcast is paused until unsubscribe and consent checks are in place." },
  { id: "inbox", label: "Inbox", icon: "📥", render: () => <EmailManagement view="inbox" />,
    description: "Replies and messages that arrived by email." },
  { id: "sent", label: "Sent log", icon: "📤", render: () => <EmailManagement view="sent" />,
    description: "Everything sent from the app, newest first." },
  { id: "privacy", label: "Privacy & legal", icon: "🛡️", render: () => <PrivacyEmailManager />,
    description: "Templated replies for privacy, takedown and legal requests." },
];

export const EMAIL_TAB_ALIASES = {
  send: "compose", emails: "compose", logs: "sent", log: "sent",
  "privacy-email": "privacy", legal: "privacy", templates: "privacy",
};

export default function EmailSection() {
  return (
    <SectionShell
      sectionId="email"
      title="Email"
      overline="COMPOSE · INBOX · SENT · PRIVACY & LEGAL"
      tabs={EMAIL_TABS}
      aliases={EMAIL_TAB_ALIASES}
    />
  );
}
